import { Text, TextProps } from "@pancakeswap/uikit";
import { useMemo } from "react";
import CountUp from "react-countup";

interface PriceProps extends TextProps {
  value: number;
  decimals?: number;
  unit?: string;
  isDisabled?: boolean;
  prefix?: string;
  noAnimation?: boolean;
  pack?: boolean;
}

const priceWithoutZero = (price: number | string) => {
    return String(price).replace(/\.(.*[^0])0+$/, ".$1").replace(/\.0+$/, "")
}

const Price: React.FC<React.PropsWithChildren<PriceProps>> = ({
  value,
  color = "text",
  decimals = 2,
  isDisabled = false,
  unit,
  prefix,
  pack = false,
  ...props
}) => {
  const [packedValue, packedUnit] = useMemo(() => {
    if (pack) {
      const units = ['', 'K', 'M', 'B']
      const k = 1000
      const i = value < 1 ? 0 : Math.floor(Math.log(value) / Math.log(k))
      return [value / k ** i, units[i]]
    }
    return [value, undefined]
  }, [pack, value])
  const formattedValue = useMemo(() => {
    const formatter = new Intl.NumberFormat('en-US')
    if(!packedValue || Number(packedValue) === 0)
        return undefined
    let fractions = 18
    if(Math.abs(packedValue) > 1)
        fractions = 2
    if(Math.abs(packedValue) > 0.0001)
        fractions = 6
    fractions = packedUnit ? decimals : Math.max(decimals, fractions)
    const [upper, under] = packedValue.toFixed(fractions).split('.')
    if(Number(upper) > 0 || fractions <= 6)
        return `${priceWithoutZero(`${formatter.format(Number(upper))}.${under ?? 0}`)}`
    const count = under.match(/0+/)?.[0].length ?? 0
    const subscripts = '₀₁₂₃₄₅₆₇₈₉'
    return priceWithoutZero(`${formatter.format(Number(upper))}.0${String(count).split('').map(n => subscripts[Number(n)]).join('')}${under.slice(count, count + 4)}`)
  }, [packedValue, packedUnit, decimals])
  
  return <Text
    color={isDisabled ? "textDisabled" : color}
    {...props}
>
    {
        formattedValue === undefined
        ? '-'
        : <>
            {prefix ?? ''}
            {formattedValue}
            {packedUnit ?? ''}
            {unit ?? ''}
        </>
    }
</Text>
};

export default Price;
